import React from 'react';
import PropTypes from 'prop-types';

const CCIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '24px';
  const h = (height) ? height.toString().concat('px') : '24px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 24 24"
      width={w}
      height={h}
    >
      <path
                // eslint-disable-next-line max-len
        d="M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V17C22 17.2652 21.8946 17.5196 21.7071 17.7071C21.5196 17.8946 21.2652 18 21 18H3C2.73478 18 3 18 2.29289 17.7071C2 17 2 17.2652 2 17V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3ZM20 10H4V16H20V10ZM20 7V5H4V7H20Z"
        fill={(fill) || '#09121F'}
      />
    </svg>
  );
};

CCIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default CCIcon;
